import { render, staticRenderFns } from "./ReleaseComponent.vue?vue&type=template&id=35618070&scoped=true"
import script from "./ReleaseComponent.vue?vue&type=script&lang=js"
export * from "./ReleaseComponent.vue?vue&type=script&lang=js"
import style0 from "./ReleaseComponent.vue?vue&type=style&index=0&id=35618070&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35618070",
  null
  
)

export default component.exports